<template>
  <vuetify-audio
    :file="file"
    :color="color"
    :pathaudio="path"
    flat
    class="audio-wrapper"
    :type="type"
    :title="title"
  />
</template>
<script>
export default {
  props: {
    file: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'accent'
    },
    path: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'block1'
    },
    title: {
      type: String,
      default: ''
    },
  },
}
</script>
